import { useState } from "react";
import { IconX } from "@tabler/icons-react";
import toast from "react-hot-toast";
import {
  useMerchantAcceptLinkMutation,
  useMerchantAllListData,
} from "../../../apis/merchantApis";
import { useLanguage } from "../../../context/LanguageContext";
import SelectInput from "../../../components/Select";

interface Props {
  id: string;
  onClose: () => void;
}

export default function AddMerchantLinkSidebar({ id, onClose }: Props) {
  const { t } = useLanguage();
  const { data: clients } = useMerchantAllListData();
  const [client, setClient] = useState("");
  const [clientError, setClientError] = useState("");

  const { mutate: linkMutate, isPending } = useMerchantAcceptLinkMutation();

  const handleClientSubmit = () => {
    if (client === "") {
      setClientError("Please select a client");
      return;
    }
    linkMutate(
      { id, clientId: client },
      {
        onSuccess: () => {
          toast.success(t("Linked Successfully"));
          window.dispatchEvent(new CustomEvent("refetchRequests"));
          onClose();
        },
        onError: (error: any) => {
          toast.error(`${error}`);
        },
      },
    );
  };

  return (
    <div className="relative bg-white rounded-3xl shadow-sm border flex flex-col overflow-hidden h-full">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-[#212121]">{t("Add Merchant")}</h2>

        <div className="flex items-center gap-3">
          <button
            onClick={handleClientSubmit}
            disabled={isPending}
            className="px-4 py-2 bg-[#FBD037] text-[#212121] rounded-lg disabled:opacity-50"
          >
            {isPending ? t("Connecting...") : t("Connect")}
          </button>

          <button
            onClick={onClose}
            className="p-2 rounded-lg border border-[#D2D2D2]"
          >
            <IconX size={20} />
          </button>
        </div>
      </div>

      <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px] flex-1 overflow-y-auto">
        <div className="grid grid-cols-1 gap-4">
          <SelectInput
            className="flex items-center space-y-0"
            name={"Select Client"}
            selectOptions={
              clients?.map((c: any) => ({
                id: c?.id,
                value: c?.id,
                text: c?.name,
              })) || []
            }
            value={client}
            setValue={(val: string) => {
              setClient(val);
              setClientError("");
            }}
          />
          {clientError && (
            <small className="text-[#DC3545] text-xs">{clientError}</small>
          )}
        </div>
      </div>
    </div>
  );
}
